import { render, staticRenderFns } from "./VaRadioImageCard.vue?vue&type=template&id=775d0986&scoped=true&"
import script from "./VaRadioImageCard.vue?vue&type=script&lang=js&"
export * from "./VaRadioImageCard.vue?vue&type=script&lang=js&"
import style0 from "./VaRadioImageCard.vue?vue&type=style&index=0&id=775d0986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d0986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
